import React, { useEffect, useState } from "react";
import axios from "axios";
import { Card, Spinner, Alert, Container, Row, Col, Badge } from "react-bootstrap";
import { FaUser, FaCodeBranch } from "react-icons/fa";
import Layout from "../../../layout/default";

const UnpinnedChildrenTree = ({ userId }) => {
    const [data, setData] = useState({
        left_leg: 0,
        mid_leg: 0,
        right_leg: 0,
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const user_name = localStorage.getItem("user_name");

    const fetchUnpinnedChildren = async () => {
        try {
            const authToken = localStorage.getItem("authToken");
            const response = await axios.get(
               `${process.env.REACT_APP_HOST}api/user/get-unpinned-childrens`,
                {
                    params: { user_id: userId },
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );

            if (response.data.success) {
                setData({
                    left_leg: response.data.left_leg || 0,
                    mid_leg: response.data.mid_leg || 0,
                    right_leg: response.data.right_leg || 0,
                });
            } else {
                setError(response.data.message || "Failed to fetch data.");
            }
        } catch (err) {
            setError(err.response?.data?.message || "Network error. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchUnpinnedChildren();
    }, [userId]);

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "200px" }}>
                <Spinner animation="border" variant="primary" />
                <span className="ms-2">Loading tree structure...</span>
            </div>
        );
    }

    if (error) {
        return (
            <Container className="mt-4">
                <Alert variant="danger" className="text-center">
                    <FaCodeBranch className="me-2" />
                    {error}
                </Alert>
            </Container>
        );
    }

    return (
        <Layout title="Unpinned Children Tree" centered>
            <Container fluid className="tree-container py-4">

                {/* Main Tree Structure */}
                <div className="tree-wrapper">
                    {/* Root Node */}
                    <div className="root-node text-center mb-4">
                        <div className="avatar-circle bg-primary">
                            <FaUser className="avatar-icon" />
                        </div>
                        <h5 className="mt-2 mb-1">{user_name}</h5>
                        <small className="text-muted">Your Network</small>
                    </div>

                    {/* Branches */}
                    <Row className="branches-row g-3 justify-content-center">
                        {/* Left Leg */}
                        <Col xs={12} sm={6} md={4} lg={3} className="branch-col">
                            <div className="branch-node left-branch">
                                <Card className="branch-card h-100">
                                    <Card.Body className="d-flex flex-column">
                                        <div className="branch-header">
                                            <div className="branch-line left-line"></div>
                                            <h6 className="branch-title">Left Leg</h6>
                                        </div>
                                        <div className="branch-content mt-auto">
                                            <Badge pill bg="info" className="count-badge">
                                                {data.left_leg}
                                            </Badge>
                                            <small className="text-muted d-block mt-1">Members</small>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </div>
                        </Col>

                        {/* Middle Leg */}
                        <Col xs={12} sm={6} md={4} lg={3} className="branch-col">
                            <div className="branch-node middle-branch">
                                <Card className="branch-card h-100">
                                    <Card.Body className="d-flex flex-column">
                                        <div className="branch-header">
                                            <div className="branch-line middle-line"></div>
                                            <h6 className="branch-title">Middle Leg</h6>
                                        </div>
                                        <div className="branch-content mt-auto">
                                            <Badge pill bg="warning" className="count-badge">
                                                {data.mid_leg}
                                            </Badge>
                                            <small className="text-muted d-block mt-1">Members</small>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </div>
                        </Col>

                        {/* Right Leg */}
                        <Col xs={12} sm={6} md={4} lg={3} className="branch-col">
                            <div className="branch-node right-branch">
                                <Card className="branch-card h-100">
                                    <Card.Body className="d-flex flex-column">
                                        <div className="branch-header">
                                            <div className="branch-line right-line"></div>
                                            <h6 className="branch-title">Right Leg</h6>
                                        </div>
                                        <div className="branch-content mt-auto">
                                            <Badge pill bg="success" className="count-badge">
                                                {data.right_leg}
                                            </Badge>
                                            <small className="text-muted d-block mt-1">Members</small>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </div>
                        </Col>
                    </Row>
                </div>
            </Container>
        </Layout>
    );
};

export default UnpinnedChildrenTree;